import { render, staticRenderFns } from "./ProblemDetails.vue?vue&type=template&id=730a87e2&scoped=true&lang=html&"
import script from "./ProblemDetails.vue?vue&type=script&lang=js&"
export * from "./ProblemDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProblemDetails.vue?vue&type=style&index=0&id=730a87e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730a87e2",
  null
  
)

export default component.exports